<template>
    <div class="Trafego-Monitoramento">
        <PageTitle icon="fa fa-cogs" main="Trafego"
            sub="Escala serviço \ Quadro de partidas \ Monitoramento \ Tabela alterada Sptrans" />
        <div class="Trafego-Monitoramento">
            <b-card no-body>
                <b-tabs>     
                                                                       
                   
                    <b-tab title="Viagens Programadas x Realizadas"><TrafegoAtividadesProgramadas /></b-tab>                    
                    <b-tab title="Tabelas alteradas Sptrans" active><TrafegoTabelaAlterada /></b-tab>
                    <b-tab title="Escala de operador"><TrafegoMonitoramentoEscala/></b-tab>
                </b-tabs>
            </b-card>
        </div>
    </div>
</template>

<script>
import PageTitle from '../template/PageTitle'
import TrafegoAtividadesProgramadas from '../trafego/TrafegoAtividadesProgramadas'
import TrafegoMonitoramentoTabela from '../trafego/TrafegoMonitoramentoTabela'
import TrafegoMonitoramentoEscala from '../trafego/TrafegoMonitoramentoEscala'
import TrafegoTabelaAlterada from '../trafego/TrafegoTabelaAlterada'
export default {
    name: 'TrafegoMonitoramento',    
    components: { PageTitle, TrafegoAtividadesProgramadas, TrafegoMonitoramentoTabela,TrafegoMonitoramentoEscala,TrafegoTabelaAlterada }
    
}
</script>

<style>

</style> 
